export const SECTIONS = {
    CONFIGURAR_PEDIDOS: 'Configurar Pedidos',
    HORARIO_FUNCIONAMENTO: 'Horário de Funcionamento',
    FRETES: 'Fretes',
    USUARIOS: 'Usuários', 
    FAIXA_CEP: "Faixas CEPs"
};

export const TIPO_ENTREGA_RETIRADA = {
    ENTREGA: 1,
    RETIRADA: 2
};

function horarios() {
    const arr = [];
    let horas, minutos;

    for (horas = 0; horas <= 23; horas++) {
        for (minutos = 0; minutos <= 45; minutos += 15) {
            let time = { value: '', label: '' };

            time.label = `${horas < 10 ? `0${horas}` : horas}:${
                minutos < 15 ? '00' : minutos
            }`;

            time.value = `${time.label}:00`;
            arr.push(time);
        }
    }

    return arr;
}

export const OPTIONS_HORARIOS = horarios();
